import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LeafBranch } from "../components/Botanical";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center px-5 overflow-hidden">
      <LeafBranch className="pointer-events-none absolute -top-6 -left-6 w-32 opacity-20" />
      <LeafBranch flip className="pointer-events-none absolute -bottom-8 -right-6 w-32 opacity-20" />

      <div className="w-full max-w-md bg-[#FAF7F2] rounded-3xl border border-[#E5DCCF] shadow-sm p-8 sm:p-10 fade-up relative z-10">
        <div className="flex flex-col items-center text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-[#3A2921] flex items-center justify-center border-2 border-[#C5A059]/40 mb-4">
            <Lock className="w-6 h-6 text-[#FDFBF7]" strokeWidth={1.6} />
          </div>
          <h1 className="font-cinzel uppercase tracking-[0.2em] text-sm text-[#3A2921]">Painel Administrativo</h1>
          <p className="font-serif-display italic text-[#9C877A] text-base mt-1">Quando Faltam Palavras</p>
        </div>

        <form onSubmit={submit} className="flex flex-col gap-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-[#6E5A4F] font-semibold">E-mail</label>
            <input
              data-testid="admin-login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1.5 w-full rounded-xl border border-[#E5DCCF] bg-[#FDFBF7] px-4 py-3 text-[#3A2921] outline-none focus:border-[#C5A059] transition-colors"
              placeholder="seu@email.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#6E5A4F] font-semibold">Senha</label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1.5 w-full rounded-xl border border-[#E5DCCF] bg-[#FDFBF7] px-4 py-3 text-[#3A2921] outline-none focus:border-[#C5A059] transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && <p data-testid="admin-login-error" className="text-sm text-red-700 text-center">{error}</p>}

          <button
            data-testid="admin-login-button"
            type="submit"
            disabled={loading}
            className="mt-2 w-full rounded-xl bg-[#3A2921] text-[#FDFBF7] py-3 font-semibold tracking-wide hover:bg-[#5C4638] transition-colors border border-[#C5A059]/40 disabled:opacity-50"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
